import L from "leaflet"

// Configure Leaflet default icons
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

export class MapConfig {
  static getTileLayerOptions() {
    return {
      url: 'https://tile.thunderforest.com/outdoors/{z}/{x}/{y}.png?apikey=627980bbb5b04faeb6b40ed3da780323',
      options: {
        minZoom: 12,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    };
  }

  static getOSMTileLayerOptions() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: {
        attribution: '&copy; OpenStreetMap contributors'
      }
    };
  }

  static getLocateControlOptions() {
    return {
      drawCircle: false,
      setView: true,
      watch: true,
      keepCurrentZoomLevel: true,
      locateOptions: {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 10000
      },
      strings: { 
        title: "Lociraj me" 
      }
    };
  }
}
